export const MAX_ITEM = 7;

export const CHART_WIDTH = 470;
export const CHART_HEIGHT = 270;

export const SHORT_MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
